const RegistrationStatusType = {
	NEW: 'Új',
	ACTIVE: 'Aktív',
	DELETED: 'Törölt',
	DISABLED: 'Letiltott'
};

export default RegistrationStatusType;
